<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Warning
      </div>
      <button
        class="ac-close-button"
        type="button"
        @click="toggleModal(false)"
      >
        <img
          src="../../assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      Changes to service offerings may require updates to your Service Titan Integration mappings.
    </div>
    <div class="ac-footer-container">
      <button
        class="sac__button-med bg-n10"
        type="button"
        @click="cancel"
      >
        Cancel
      </button>
      <button
        class="sac__button-med bg-default"
        type="button"
        @click="save"
      >
        Proceed
      </button>
    </div>
    <ProcessOverlay
      :show="loading"
      text="Updating setting.."
      overlayClass="ac-overlay"
    />
  </div>
</template>
<script>

import partnerSettingsMixin from '../../mixins/partnerSettingsMixin';
import settingMixin from '../../mixins/settingMixin';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'SettingChangesWarning',
  components: {ProcessOverlay},
  mixins: [partnerSettingsMixin, settingMixin],
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.toggleModal(false);
    },
    async save() {
      const route = this.$route.path;
      const isPartnerRouter = route.includes('partner');
      this.loading = true;
      if (isPartnerRouter) {
        await this.$store.dispatch('updatePartnerSetting', this.servicesOffering);
      } else {
        await this.$store.dispatch('updateCorporationSetting', this.servicesOffering);
      }
      this.loading = false;
      this.toggleModal(false);
    },
  },
};
</script>
